import React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";
import PropTypes from "prop-types";
import { I18n } from "@aws-amplify/core";
import { isEmpty, get } from "lodash";

import {
  setFieldValue,
  clearStore,
} from "../../../actions/siteEntranceExit/correctConfirmValue";

import Grid from "@material-ui/core/Grid";
import Tabs from "@material-ui/core/Tabs";

import CloseIcon from "../../Common/CloseIcon";
import CustomTab from "../../Common/CustomTab";
import CapturedPhotosContainer from "../CapturedPhotosContainer";
import Correction from "./Correction";
import PotentialMatches from "./PotentialMatches";
import Metadata from "./Metadata";

import { getOcrLprFromPhotos } from "../../../utils/detectionDetails";

import images from "../../../assets/img/images";

const styles = {
  closeBtn: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "16px 10px",
    "& img": {
      cursor: "pointer",
    },
  },
  tabIndicator: {
    display: "none",
  },
};

const ValueDetails = (props) => {
  const {
    dispatch,
    classes,
    close,
    initialValue,
    setInitialValue,
    photos,
    profileType,
    profile,
    detectionEventGroup,
    setOverrideData,
    reloadEventGroupAndFocusElement,
  } = props;
  const [tab, setTab] = React.useState(0);

  const focusElement = setInitialValue
    ? initialValue
    : get(props, [
        "siteEntranceExit",
        props.section,
        "correctConfirmValue",
        "focusElement",
      ]);

  React.useEffect(() => {
    // I think the intention of this is to update the focusElement store when
    // the rest of the component updates the initialValue by calling 
    // setInitialValue  Not sure, this looks rather redundant
    // TODO: test to see what this does when initial value changes
    if (isEmpty(focusElement)) {
      dispatch(setFieldValue(props.section, "focusElement", initialValue));
    } else {
      let updatedFocusElement = photos.filter(
        (p) => p.url === focusElement.url
      );
      if (updatedFocusElement && updatedFocusElement.length > 0) {
        dispatch(
          setFieldValue(props.section, "focusElement", updatedFocusElement[0])
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialValue]);

  if (isEmpty(focusElement)) {
    return null;
  }

  return (
    <Grid container direction="column" wrap="nowrap" style={{ height: "100%" }}>
      <Grid item>
        <Grid container wrap="nowrap">
          <Grid item xs={2}></Grid>
          <Grid item xs>
            <Tabs
              value={tab}
              onChange={(obj, value) => setTab(value)}
              centered
              classes={{ indicator: classes.tabIndicator }}
            >
              <CustomTab height="40px" label={I18n.get("site_correction")} />
              {props.powerUserModeEnabled && (
                <CustomTab height="40px" label={I18n.get("site_metadata")} />
              )}
            </Tabs>
          </Grid>
          <Grid item xs={2} className={classes.closeBtn + " text-87"}>
            <CloseIcon
              closeFunction={() => {
                dispatch(clearStore(props.section));
                close();
              }}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid
        item
        className="text-87 bold-500 flexCenter"
        style={{ paddingTop: "5px", justifyContent: "center" }}
      >
        {I18n.get("site_currentProfile")}
        <img
          style={{ marginLeft: "8px", marginRight: "8px", maxWidth: "35px" }}
          src={
            profileType === 2 ? images.truckIconBlack : images.trailerIconBlack
          }
          alt="vehicle"
          height="18px"
        />
        {profile
          ? profile.name
          : profileType === 2
          ? I18n.get("site_unknownTruck")
          : I18n.get("site_unknownTrailer")}
      </Grid>
      <Grid item xs style={{ maxHeight: "100%", overflow: "auto" }}>
        <Grid
          container
          direction="column"
          wrap="nowrap"
          style={{ height: "100%" }}
        >
          <Grid item style={{ paddingTop: "5px", width: "100%" }}>
            <CapturedPhotosContainer
              photos={photos}
              selectedPhoto={focusElement && focusElement.url}
              onClickPhoto={(element) =>
                setInitialValue
                  ? setInitialValue(element)
                  : dispatch(
                      setFieldValue(props.section, "focusElement", element)
                    )
              }
            />
          </Grid>
          {tab === 0 ? (
            <Grid item xs style={{ margin: "10px" }}>
              <Grid container style={{ height: "100%" }}>
                <Grid item style={{ width: "350px" }}>
                  <Correction
                    focusElement={focusElement}
                    profileType={profileType}
                    detectionEventGroup={detectionEventGroup}
                    reloadEventGroupAndFocusElement={reloadEventGroupAndFocusElement}
                  />
                </Grid>
                <Grid item style={{ width: "calc(100% - 350px)" }}>
                  <PotentialMatches
                    section={props.section}
                    searchValues={getOcrLprFromPhotos(photos)}
                    focusElement={focusElement}
                    profile={profile}
                    setOverrideData={setOverrideData}
                  />
                </Grid>
              </Grid>
            </Grid>
          ) : (
            <Metadata focusElement={focusElement} />
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

ValueDetails.propTypes = {
  close: PropTypes.func.isRequired,
  initialValue: PropTypes.object,
  photos: PropTypes.array.isRequired,
  profileType: PropTypes.oneOf([2, 3, 8]).isRequired,
  profile: PropTypes.object,
  detectionEventGroup: PropTypes.object,
  setOverrideData: PropTypes.func.isRequired,
  reloadEventGroupAndFocusElement: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  return {
    powerUserModeEnabled: state.common.powerUserModeEnabled,
    siteEntranceExit: state.siteEntranceExit,
  };
};

export default connect(mapStateToProps)(withStyles(styles)(ValueDetails));
